import React from "react";
import { ImageField, ImageInput, required, useNotify } from "react-admin";
import { Box, IconButton, Typography } from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";
import FormModal from "server/components/Modals/FormModal";

const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5 MB

const validateImageSize = value =>
  value?.rawFile && value.rawFile.size > MAX_IMAGE_SIZE ? "Снимката надвишава максималния размер от 5 MB" : undefined;

const UpdateStudentAvatarDialog = ({ studentId, onUpdated }) => {
  const notify = useNotify();

  const handleSubmit = async formData => {
    await dataProvider.customRequest(
      studentRequests.updateStudentProfilePicture(studentId),
      { File: formData.picture },
      "PUT",
      null,
      true,
    );
    notify("Снимката е обновена успешно", { type: "success" });
    onUpdated?.();
  };

  return (
    <FormModal
      titleContent="Обновяване на профилна снимка"
      onConfirm={handleSubmit}
      triggerButton={
        <IconButton
          aria-label="Промяна на снимка"
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            width: 32,
            height: 32,
            bgcolor: "primary.main",
            color: "#fff",
            border: "2px solid #fff",
            "&:hover": { bgcolor: "primary.dark" },
          }}
        >
          <DriveFileRenameOutlineIcon fontSize="medium" />
        </IconButton>
      }
    >
      <ImageInput
        source="picture"
        label="Профилна снимка"
        accept="image/*"
        validate={[required(), validateImageSize]}
        placeholder={
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2, py: 0.5 }}>
            <PhotoCamera color="primary" />
            <Typography>Добавете снимка (макс. 5 MB)</Typography>
          </Box>
        }
      >
        <ImageField
          source="src"
          title="title"
        />
      </ImageInput>
    </FormModal>
  );
};

export default UpdateStudentAvatarDialog;
